import { CATALOGUE_POLICES, policesDeLaCharte } from '../../contract/index.js';
import { Corps } from './Corps.js';
import { cssCimaise } from './css.js';
/**
 * Polices du thème : déclarées, jamais téléchargées (D12). La publication
 * copie ces fichiers depuis le dépôt de polices d'Artosera vers `/fonts/`.
 */
function assets(charte) {
    return policesDeLaCharte(charte).flatMap((nom) => {
        const definition = CATALOGUE_POLICES[nom];
        return definition.fichiers.map((fichier) => ({
            chemin: fichier.chemin,
            type: 'police',
            description: `${definition.famille} ${String(fichier.graisse)} ${fichier.style}`,
        }));
    });
}
/**
 * Thème **Cimaise**, d'après `designs/a-cimaise.html` : cube blanc, vide
 * organisé, Familjen Grotesk, aucune icône.
 */
export const cimaise = {
    nom: 'cimaise',
    feuilleDeStyle: '/assets/cimaise.css',
    assets,
    css: cssCimaise,
    Corps,
};
export { cssCimaise };
//# sourceMappingURL=index.js.map